"use client";

import { Button } from "@dafiti/closet-ui";
import { Filter, Trash } from "@dafiti/closet-ui/icons";
import { useTranslations } from "next-intl";

interface QuickFilterFooterProps {
  onClear: () => void;
  onApply: () => void;
  size?: "md" | "lg";
}

export function QuickFilterFooter({
  onClear,
  onApply,
  size = "md",
}: QuickFilterFooterProps) {
  const t = useTranslations("catalog");

  return (
    <div
      className="flex shrink-0 gap-3xs lg:max-w-[312px] px-0 pt-6 pb-6 lg:px-4 lg:pt-2 lg:pb-4 bg-white border-support-100 lg:border-2 lg:border-t-0 rounded-b-3xl lg:shadow-[0_8px_16px_0_rgba(0,0,0,0.16)]"
      data-testid="quick-filter-footer"
    >
      <Button
        variant="secondary"
        size={size}
        className="flex-1 gap-1"
        onClick={onClear}
        aria-label={t("actions.clearSelection")}
        data-testid="quick-filter-clear-button"
      >
        <div className="flex h-6 w-6 items-center justify-center">
          <Trash aria-hidden="true" className="size-4" />
        </div>
        {t("actions.clear")}
      </Button>

      <Button
        size={size}
        className="flex-1 gap-1"
        onClick={onApply}
        aria-label={t("actions.filter")}
        data-testid="quick-filter-apply-button"
      >
        <div className="flex h-6 w-6 items-center justify-center">
          <Filter aria-hidden="true" className="size-4" />
        </div>
        {t("actions.filter")}
      </Button>
    </div>
  );
}
